module.exports = __webpack_public_path__ + "static/media/Albert Gore, Jr. - 2000.883db505.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Albert Gore, Jr. - 2000.jpg
// module id = 432
// module chunks = 0